import React, { useEffect, useState } from "react";
import { GetJobStatus, JobApplyList, getManageMessage, saveManageMessage } from "redux/features/PostJobSlice";
import { useDispatch } from "react-redux";
import CustomTab from "components/Tab";
import JobAppliedList from "./JobAppliedList";
import { Notification } from "components/CustomNotification";
import { JobApplyListStyle, ManageMessageModel } from "./JobActivity.style";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import { ReactComponent as ExpandMoreIcon } from "assert/images/Common/arrowDown.svg";
import { ReactComponent as MessageEdit } from "assert/images/Jobs/messageEdit.svg";

import { BrandIconSpinner, Button, Input, Modal } from "components";
import { DialogActions } from "@mui/material";
import { rejectedDefaultMail, selectedDefaultMail } from "utils/Constant";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const loadSize = 15;
const minMaxRowLength = 7;

export default function JobAppliedTab() {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [jobApplylist, setJobApplylist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [tabKey, setTabKey] = useState(0);
  const [isDisplayMsg, setIsDisplayMsg] = useState(false);
  const [showAlert, setShowAlert] = useState(true);
  const [openDeleteModel, setOpenDeleteModel] = useState(null);
  const [state, setState] = useState({
    rejected: "",
    selected: "",
    held: "",
  });
  const [savedMsg, setSavedMsg] = useState({
    rejected: "",
    selected: "",
    held: "",
  });

  useEffect(() => {
    setLoading(true);
    dispatch(getManageMessage())
      .then((response) => {
        const resData = response?.data;
        setState({
          rejected: resData?.rejected || rejectedDefaultMail,
          selected: resData?.selected || selectedDefaultMail,
          held: resData?.held,
        });
        setSavedMsg({
          rejected: resData?.rejected,
          selected: resData?.selected,
          held: resData?.held,
        });
        setLoading(false);
      })
      .catch((err) => {
        Notification("error", err.response?.data?.message);
        setLoading(false);
      });
  }, []);

  const handleFetchData = (status) => {
    if (status === 0) {
      dispatch(JobApplyList(id, page, loadSize))
        .then((response) => {
          setJobApplylist(response?.data?.data);
          setLoading(false);
          setPage(page + 1);
        })
        .catch((err) => {
          Notification("error", err.response?.data?.message);
          setLoading(false);
        });
    } else {
      dispatch(GetJobStatus({ id, status: status - 1 }, page, loadSize))
        .then((response) => {
          setJobApplylist(response?.data?.data);
          setLoading(false);
          setPage(page + 1);
        })
        .catch((err) => {
          Notification("error", err.response?.data?.message);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    id && handleFetchData(tabKey);
  }, [id, tabKey]);

  const jobAppliedList = (
    <JobAppliedList
      jobApplylist={jobApplylist}
      loading={loading}
      handleFetchData={handleFetchData}
      tabKey={tabKey}
      state={savedMsg}
      handleManageMsgOpen={() => setIsDisplayMsg(true)}
      showAlert={showAlert}
      openDeleteModel={openDeleteModel}
      setShowAlert={setShowAlert}
      setOpenDeleteModel={setOpenDeleteModel}
    />
  );
  const Tablist = [
    {
      label: t('profile.AppliedList'),
      content: jobAppliedList,
    },
    {
      label: t('profile.OnHold'),
      content: jobAppliedList,
    },
    {
      label: t('profile.Selected'),
      content: jobAppliedList,
    },
    {
      label: t('profile.Rejected'),
      content: jobAppliedList,
    },
  ];

  const handleChangeInput = (data, name) => {
    setState((prevState) => ({
      ...prevState,
      [name]: data,
    }));
  };

  const handleSaveMessage = () => {
    if (!state.rejected || !state.selected) {
      Notification("info", "Please save all the required fields");
      return;
    }
    setLoading(true);
    dispatch(saveManageMessage(state))
      .then((response) => {
        Notification("info", response?.data?.message);
        setLoading(false);
        setIsDisplayMsg(false);
        setSavedMsg(state);
      })
      .catch((err) => {
        Notification("error", err.response?.data?.message);
        setLoading(false);
        setIsDisplayMsg(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>Applied Candidates | WafyNet - Manage Job Applications</title>
        <meta
          name="description"
          content="View and manage the list of candidates who have applied to your job postings on WafyNet. Connect with top talent and grow your team."
        />
      </Helmet>
      <JobApplyListStyle>
        <div className="job-apply-tab-container">
          <CustomTab
            defaultTabValue={0}
            tabList={Tablist}
            handleTabChange={(key) => {
              setJobApplylist([]);
              setPage(0);
              setTabKey(key);
              setLoading(true);
            }}
          />
          <Button
            className="job-apply-msg"
            label={t('profile.ManageMessage')}
            variant="outlined"
            startIcon={<MessageEdit />}
            onClick={() => setIsDisplayMsg(true)}
          />
        </div>
        <Modal
          content={
            <ManageMessageModel>
              <BrandIconSpinner loading={loading} />
              <div className="message-notes">{t('profile.AppropriateMsg')}</div>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                {t('profile.RejectedMessage')}&nbsp;<span className="requiredSymbol">*</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Input
                    defaultValue={state.rejected}
                    multiline
                    maxLimit={1000}
                    minRows={minMaxRowLength}
                    maxRows={minMaxRowLength}
                    value={state.rejected}
                    onChange={(data) => handleChangeInput(data, "rejected")}
                  />
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
                  {t('profile.SelectedMessage')}&nbsp;<span className="requiredSymbol">*</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Input
                    defaultValue={state.selected}
                    multiline
                    maxLimit={1000}
                    minRows={minMaxRowLength}
                    maxRows={minMaxRowLength}
                    value={state.selected}
                    onChange={(data) => handleChangeInput(data, "selected")}
                  />
                </AccordionDetails>
              </Accordion>
              {/* <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3-content" id="panel3-header">
                On Hold Message
              </AccordionSummary>
              <AccordionDetails>
                <Input
                  multiline
                  maxLimit={1000}
                  minRows={minMaxRowLength}
                  maxRows={minMaxRowLength}
                  value={state.held}
                  onChange={(data) => handleChangeInput(data, "held")}
                />
              </AccordionDetails>
            </Accordion> */}
              <DialogActions>
                <Button variant="text" label={t('profile.Save')} onClick={handleSaveMessage} />
                <Button variant="text" label={t('profile.Cancel')} customStyles="cancel-btn" onClick={() => setIsDisplayMsg(false)} />
              </DialogActions>
            </ManageMessageModel>
          }
          openModal={isDisplayMsg}
          handleCancelModal={() => setIsDisplayMsg(false)}
          modelTitle={t('profile.ManageMessage')}
          modalchanges={"manage_message"}
        />
      </JobApplyListStyle>
    </>
  );
}
